import {
  gql 
} from "@apollo/client"

import {
  PriceSummaryFragment 
} from "@/hooks/CartPage/PriceSummary/priceSummaryFragments.gql"
import {
  GiftCardFragment 
} from "./GiftCards/giftCardFragments.gql"
import {
  AppliedCouponsFragment 
} from "./PriceAdjustments/CouponCode/couponCodeFragments.gql"
import {
  ProductListingFragment 
} from "./ProductListing/productListingFragments.gql"

export const CartPageFragment = gql`
    fragment CartPageFragment on Cart {
        id
        cross_sells_products {
            id
            uid
            name
            price_range {
                maximum_price {
                    final_price {
                        currency
                        value
                    }
                    regular_price {
                        currency
                        value
                    }
                    discount {
                        amount_off
                    }
                }
                minimum_price {
                    final_price {
                        currency
                        value
                    }
                    regular_price {
                        currency
                        value
                    }
                    discount {
                        amount_off
                    }
                }
            }
            sku
            small_image {
                url
            }
            stock_status
            rating_summary
            review_count
            __typename
            url_key
        }
        amasty_rewards_used_points {
            used_points
        }
        total_quantity
        ...AppliedCouponsFragment
        ...GiftCardFragment
        ...ProductListingFragment
        ...PriceSummaryFragment
    }
    ${AppliedCouponsFragment}
    ${GiftCardFragment}
    ${ProductListingFragment}
    ${PriceSummaryFragment}
`
